<script setup>
import {router, usePage} from '@inertiajs/vue3';
import {useI18n} from 'vue-i18n';
import {Menu, MenuButton, MenuItem, MenuItems} from '@headlessui/vue';
import {ChevronDownIcon} from '@heroicons/vue/20/solid';
import {computed} from 'vue';
import Button from '@/Components/Inputs/Button.vue';

defineProps({
    dark: Boolean,
});

const i18n = useI18n();
// The current locale
const locale = computed(() => usePage().props.locale);
const switchLocale = (locale) => {
    i18n.locale.value = locale;


    if (usePage().props.route.locale[locale]) {
        router.get(usePage().props.route.locale[locale], {}, { preserveScroll: true });
    }
};

const locales = computed(() => {
    return Object.entries(usePage().props.route.locale)
        .map(([key, value]) => ({ key, value }))
        .filter((locale) => locale.value);
});
</script>

<template>
    <div
        v-if="locale && locales.length > 1"
        class="flex items-center"
    >
        <Menu
            as="div"
            class="relative flex items-center text-left"
        >
            <MenuButton
                :class="dark ? 'text-black' : 'text-white'"
                class="inline-flex w-full justify-center gap-x-1.5 rounded-md text-sm font-semibold"
            >
                <ChevronDownIcon
                    aria-hidden="true"
                    class="-mr-1 size-5"
                />
                {{ locale.toUpperCase() }}
            </MenuButton>

            <transition
                enter-active-class="transition ease-out duration-100"
                enter-from-class="transform opacity-0 scale-95"
                enter-to-class="transform opacity-100 scale-100"
                leave-active-class="transition ease-in duration-75"
                leave-from-class="transform opacity-100 scale-100"
                leave-to-class="transform opacity-0 scale-95"
            >
                <MenuItems
                    class="absolute right-0 z-10 mt-2 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none"
                >
                    <div class="py-1">
                        <MenuItem
                            v-for="locale in locales"
                            :key="locale.key"
                            v-slot="{ active }"
                        >
                            <Button
                                :class="[
                                    active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                                    'block px-4 py-2 text-sm',
                                ]"
                                disable-style
                                @click="switchLocale(locale.key)"
                            >
                                {{ locale.key.toUpperCase() }}
                            </Button>
                        </MenuItem>
                    </div>
                </MenuItems>
            </transition>
        </Menu>
    </div>
</template>
